import type { KeypadGridProps } from './index.types';
import { DIGIT_GRID, DIGIT_LABELS } from 'Modules/softphone/constants';
import { useSoftphoneKeypad } from 'Modules/softphone/hooks';
import React from 'react';
import { KeypadButton } from './KeypadButton';

/**
 * KeypadGrid Component
 * 3x4 grid of DTMF keypad buttons
 */
export const KeypadGrid = ({
  testID,
  className,
}: KeypadGridProps): React.ReactElement => {
  const keypadGridTestId = testID ? `${testID}-keypad-grid` : 'keypad-grid';

  const { handleDigitPress } = useSoftphoneKeypad();

  return (
    <div
      id="keypad-grid"
      className={className}
      role="group"
      aria-label="DTMF keypad buttons"
      data-testid={keypadGridTestId}
    >
      {DIGIT_GRID?.map((row) =>
        row.map((digit) => (
          <KeypadButton
            key={digit}
            digit={digit}
            label={DIGIT_LABELS[digit]}
            onClick={handleDigitPress}
            testID={`${keypadGridTestId}-digit-${digit}`}
          />
        ))
      )}
    </div>
  );
};
